<template>
    <div class="border px-3 rounded editor" :class="{ 'border-danger': hasError }">
        <!-- Bar -->
        <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
            <div class="text-editor-menu-bar">

                <!-- Typography -->
                <span class="border-light-grey border-end-md me-0 pe-0 me-md-2 pe-md-3">
                    <button
                            class="p-1 text-editor-button hover-secondary"
                            :class="{ 'is-active': isActive.bold() }"
                            @click.prevent="commands.bold"
                    >
                        <Icon icon="bold" />
                    </button>
                    <button
                            class="p-1 text-editor-button hover-secondary"
                            :class="{ 'is-active': isActive.italic() }"
                            @click.prevent="commands.italic"
                    >
                        <Icon icon="italic" />
                    </button>
                    <button
                            class="p-1 text-editor-button hover-secondary"
                            :class="{ 'is-active': isActive.strike() }"
                            @click.prevent="commands.strike"
                    >
                        <Icon icon="strikethrough" />
                    </button>
                    <button
                            class="p-1 text-editor-button hover-secondary"
                            :class="{ 'is-active': isActive.bullet_list() }"
                            @click.prevent="commands.bullet_list"
                    >
                        <Icon icon="list" />
                    </button>
                </span>
                <!-- / Typography -->

                <!-- Undo/Redo -->
                <span>
                    <button
                            class="p-1 text-editor-button hover-secondary"
                            @click.prevent="commands.undo"
                    >
                        <Icon icon="undo" />
                    </button>

                    <button
                            class="p-1 text-editor-button hover-secondary"
                            @click.prevent="commands.redo"
                    >
                        <Icon icon="redo" />
                    </button>
                </span>
                <!-- / Undo/Redo -->

            </div>
        </editor-menu-bar>
        <!-- Textfield -->
        <editor-content
                class="py-1"
                v-if="editor"
                :editor="editor"
        />
    </div>
</template>
<script>
    import {Editor, EditorContent, EditorMenuBar} from 'tiptap'
    import {Bold, Italic, Strike, BulletList, ListItem, HardBreak, History, Placeholder} from 'tiptap-extensions'

    export default {
        name: 'editor',
        props: {
            value: String,
            hasError: Boolean,
            placeholder: String
        },
        components: {
            EditorContent,
            EditorMenuBar,
        },
        data() {
            return {
                editor: null
            }
        },
        mounted() {
            this.editor = new Editor({
                extensions: [
                    new Bold(),
                    new Italic(),
                    new Strike(),
                    new BulletList(),
                    new ListItem(),
                    new HardBreak(),
                    new History(),
                    new Placeholder({
                        emptyEditorClass: 'is-editor-empty',
                        emptyNodeClass: 'is-empty',
                        emptyNodeText: this.placeholder,
                        showOnlyWhenEditable: true,
                        showOnlyCurrent: true,
                    }),
                ],
                content: this.value,
                onUpdate: ({getHTML}) => {
                    this.$emit('input', getHTML())
                }
            })
            this.editor.setContent(this.value)
        },
        watch: {
            'value': function (val) {
                if (this.editor && val !== this.editor.getHTML()) {
                    this.editor.setContent(val, true)
                }
            }
        },
        beforeDestroy() {
            this.editor.destroy()
        }
    }
</script>


<style>
    .text-editor-menu-bar {
        padding: 0.9rem 0;
        border: none;
    }

    .text-editor-button {
        padding: 0.5rem 1rem;
        border: none;
        background: none;
    }

    .editor p.is-editor-empty:first-child::before {
        content: attr(data-empty-text);
        float: left;
        color: #aaa;
        pointer-events: none;
        height: 0;
        font-style: italic;
    }
</style>